import { LOGOUT_IFRAME_EVENT_KEY, REFRESH_IFRAME_TOKEN_EVENT_KEY } from "./constants";
import { isHostControl, isHostCockpitItaly } from "./urlUtils";
import { AuthService } from "./AuthService";

const authorization = new AuthService();

export const getAccessToken = () => authorization.getAccessToken();
export const getCockpitUser = () => authorization.getCockpitUser();
export const getUser = () => authorization.getUser();
export const loginSilently = () => authorization.loginSilently();
export const loginWithRedirect = () => authorization.loginWithRedirect();
export const registerWithRedirect = () => authorization.registerWithRedirect();
export const logout = (url?: string) => authorization.logout(url);
export const refreshToken = () => authorization.refreshToken();

export function sendAccessTokenToIFrame(iframe: HTMLIFrameElement, host: string): Promise<void> {
    return getAccessToken().then((token) => {
        const message = { key: REFRESH_IFRAME_TOKEN_EVENT_KEY, value: token };
        iframe.contentWindow?.postMessage(message, host);
    });
}

export function logoutInIFrame(iframe: HTMLIFrameElement, host: string): void {
    const message = { key: LOGOUT_IFRAME_EVENT_KEY };
    iframe.contentWindow?.postMessage(message, host);
}

/**
 * @deprecated It only evaluates host once auth-provider is loaded. Please use {@link isAppControl}.
 */
export const isControlApp: boolean = isHostControl();

export const isAppControl = isHostControl;
export const isCockpitItaly = isHostCockpitItaly;
